import {font_s_sm} from '@xpertdox_js/xdstyle';

export default {
  displayBox: {
    marginBottom: '6px',
    paddingBottom: '4px',
    borderBottom: '1px dotted rgba(0,0,0,0.1)',
    background: 'rgba(0,0,0,0.04)',
    padding: '4px',
    marginRight: '6px',
  },
  topLevelText: {
    margin: '0 auto 2px',
  },
  childProperty: {
    display: 'inline-block',
    margin: '0 4px 0 12px',
    ...font_s_sm,
  },
  childValue: {
    ...font_s_sm,
  }
}
